// Persists supervisor (ghost) impersonated employer for SSR; not stored in /users/me.
export default function () {
  return useCookie('pp_supervisor_employer', {
    path: '/',
    maxAge: 60 * 60 * 24, // 1 day
    sameSite: 'lax',
    default: () => null,
    watch: true
  })
}
